<template>
  <div>
    <v-date-picker range
                   placeholder="请选择时间段"
                   style="width:270px;"
                   v-model="rangeDate"
                   clearable
                   @confirm="confirm"
                   @change="rangeChange"></v-date-picker>
    <v-select style="width: 180px;"
              :data="appOptions"
              placeholder="选择产品组"
              :allowClear="false"
              @change="changeApp"
              v-model="appValue"></v-select>
    <v-select style="width: 180px;"
              :data="statusOptions"
              placeholder="选择发票状态"
              @change="changeStatus"
              :allowClear="false"
              v-model="statusValue"></v-select>
    <v-input placeholder="发票订单号查询"
             v-model="invoiceId"
             style="width:200px;display:inline-block"></v-input>
    <v-button type="primary"
              @click="handleSearch">筛选</v-button>
    <div style="height:20px;"></div>
    <el-table :data="tableData"
              style="width: 100%">
      <el-table-column prop="invoice_id"
                       width="230px"
                       label="发票订单号">
        <template slot-scope="scope">
          <div>
            <span style="font-size: 5px">{{scope.row.invoice_id}}</span>
            <el-button type="text"
                       style="font-size: 5px"
                       @click="handleDetail(scope.row)"
                       size="small">详情</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time"
                       width="180px"
                       label="申请时间">
      </el-table-column>
      <el-table-column prop="app_key"
                       width="130px"
                       label="产品组">
        <template slot-scope="scope">
          <span>{{appOptions.filter((item)=>{return item.value==scope.row.app_key})[0].label}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state"
                       width="110px"
                       label="状态">
        <template slot-scope="scope">
          <span>{{statusOptions.filter((item)=>{return item.value === scope.row.state})[0].label}}</span>
        </template>
      </el-table-column>
      <el-table-column width="180px" label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     v-if="scope.row.state===0"
                     @click="handleUpload(scope.row)"
                     size="small">上传发票</el-button>
          <el-button type="text"
                     v-if="scope.row.state===0"
                     @click="handleReject(scope.row)"
                     size="small">驳回</el-button>
          <el-button type="text"
                     v-if="scope.row.state===1"
                     @click="handleShowPDF(scope.row)"
                     size="small">查看发票</el-button>
          <el-button type="text"
                     v-if="scope.row.state===1"
                     @click="handleUpload(scope.row)"
                     size="small">重新上传</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="remark"
                       width="130px"
                       label="备注">
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total, prev, pager, next"
      style="float: right"
      :current-page="pageNum"
      @current-change="handleCurrentChange"
      :total="total">
    </el-pagination>
    <v-modal title="发票详情"
             id="self-modal"
             :visible="detailVisible"
             @ok="detailVisible=false"
             @cancel="detailVisible=false">
      <div style="text-align: left">
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">公司名称：</p>
          <p style="width:270px">{{detailInfo.rise_name?detailInfo.rise_name:'未填写'}}</p>
        </div>
        <div v-if="detailInfo.rise_key!==''" style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">公司税号：</p>
          <p style="width:270px">{{detailInfo.rise_key?detailInfo.rise_key:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">公司地址：</p>
          <p style="width:270px">{{detailInfo.address?detailInfo.address:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">电话号码：</p>
          <p style="width:270px">{{detailInfo.company_phone?detailInfo.company_phone:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">开户银行：</p>
          <p style="width:270px">{{detailInfo.bank_name?detailInfo.bank_name:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">银行账号：</p>
          <p style="width:270px">{{detailInfo.bank_id?detailInfo.bank_id:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">电子邮箱：</p>
          <p style="width:270px">{{detailInfo.email?detailInfo.email:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">电子邮箱：</p>
          <p style="width:270px">{{detailInfo.email?detailInfo.email:'未填写'}}</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">开票金额：</p>
          <p style="width:270px">{{detailInfo.fee/100}}元</p>
        </div>
        <div style="margin: 10px;display: flex">
          <p style="margin: 0px 20px 0px 40px;width:120px;text-align: right">上传发票名称：</p>
          <p style="width:270px;word-break: normal">{{detailInfo.filename?detailInfo.filename:'未填写'}}</p>
        </div>
      </div>
    </v-modal>
    <v-modal title="请输入驳回原因"
             :visible="rejectVisible"
             @ok="confirmReject"
             @cancel="rejectVisible=false">
      <v-input maxLength="50" type="textarea" autosize v-model="rejectMark"></v-input>
    </v-modal>
    <v-modal title="请上传发票文件"
             :visible="uploadVisible"
             @ok="confirmUpload"
             @cancel="uploadVisible=false">
      <div style="display: flex;align-items: center">
        <a class="a-upload">
          <input id="invoice" @change="onChange" type="file"><v-icon type="upload"></v-icon>上传发票
        </a>
        <span>{{uploadName}}</span>
      </div>
    </v-modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      action: '',
      invoiceId: '',
      rangeDate: ['', ''],
      rejectVisible: false,
      appOptions: [],
      appValue: '',
      statusOptions: [{value: '', label: '全部'}, {value: 0, label: '待开票'}, {value: 1, label: '开票成功'}, {value: 2, label: '开票失败'}],
      statusValue: '',
      detailVisible: false,
      tableData: [],
      detailInfo: {},
      rejectMark: '',
      uploadVisible: false,
      uploadPDFKey: '',
      uploadName: '',
      total: 0,
      pageNum: 1
    }
  },
  methods: {
    getObjectURL (file) {
      let url = null
      if (window.createObjectURL !== undefined) { // basic
        url = window.createObjectURL(file)
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      } else if (window.URL !== undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      }
      return url
    },
    handleShowPDF (item) {
      let url = item.url
      // 当然上面的是可以的，但是此access_token 是有时效性的，只是放在这边当作个例子，至于最后我为什么加了个测试.pdf 是可以在浏览器标签叶上显示
      window.open('/static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
    },
    changeStatus () {
      console.log()
    },
    handleUpload (item) {
      this.detailInfo = item
      this.uploadVisible = true
      this.uploadName = ''
      this.uploadPDFKey = ''
    },
    onChange (e) {
      let file = e.target.files[0]
      this.uploadName = file.name
      let reader = new FileReader()
      reader.readAsArrayBuffer(file)
      let that = this
      reader.onload = function () {
        axios.get('/dev/put_invoice_key', {params: {sign_headers: '{"Content-Type":"application/octet-stream"}'}}).then(res => {
          that.action = res.data.send_url
          that.uploadPDFKey = res.data.key
          that.uploadVisible = true
          if (res.data.code === 200) {
            axios.put(that.action, this.result, {
              headers: {'Content-Type': 'application/octet-stream'}
            }).then(res => {
              console.log()
            })
          }
        })
      }
    },
    confirmUpload () {
      let url = `/dev/invoice/${this.detailInfo.invoice_id}/check`
      axios.post(url, {key: this.uploadPDFKey, filename: this.uploadName}).then(res => {
        this.uploadVisible = false
        this.search()
      })
    },
    handleReject (item) {
      this.detailInfo = item
      this.rejectVisible = true
    },
    confirmReject () {
      let url = `/dev/invoice/${this.detailInfo.invoice_id}/reject`
      axios.post(url, {remark: this.rejectMark})
        .then(res => {
          this.rejectVisible = false
          this.search()
        })
    },
    // 详情调转方法
    handleDetail (item) {
      this.detailVisible = true
      this.detailInfo = item
    },
    rangeChange (startTime, endTime) {
      console.log()
    },
    confirm () {
      console.log()
    },
    changeApp () {
      console.log()
    },
    handleSearch () {
      this.pageNum = 1
      this.search()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.search()
    },
    search () {
      let startTime, endTime, appValue
      startTime = this.rangeDate[0]
      endTime = this.rangeDate[1]
      appValue = this.appValue === 'ALL' ? '' : this.appValue
      let url = '/dev/invoice/factor'
      url = url + '?app_key=' + appValue + '&state=' + this.statusValue + '&invoice_id=' + this.invoiceId + '&start_time=' + startTime + '&finish_time=' + endTime + '&page=' + this.pageNum
      axios.get(url)
        .then(res => {
          let arr = []
          this.total = res.data.page_total
          arr = res.data.data
          this.tableData = arr
        })
    },
    getApps () {
      axios.get('/dev/package_info').then(res => {
        let arr = [{value: 'ALL', label: '全部'}]
        // let arr = []
        res.data.package_info.forEach(item => {
          let obj = {}
          obj.value = item.value
          obj.label = item.key
          arr.push(obj)
        })
        this.appOptions = arr
        this.appValue = arr[0].value
      })
    }
  },
  created () {
    this.getApps()
    this.handleSearch()
  }
}
</script>

<style scoped>
  .a-upload {
    padding: 0px 10px;
    margin-right:10px ;
    height: 35px;
    line-height: 35px;
    position: relative;
    cursor: pointer;
    color: #333333;
    background: white;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    text-decoration: none;
  }

  .a-upload  input {
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer
  }

  .a-upload:hover {
    color: #108ee9;
    border-color: #108ee9;

  }
  #self-modal{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/invoices/invoices.vue